const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/user-management/api-factory');
const serviceFactory = require('../resources/user-management/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/usermgmt/${apiConfig.apiversion}/`
    // authToken: config.authToken,
  });

  const service = serviceFactory({ api });
  const p = '[{keys:metaData}].';

  return app => app
    .match(`${p}usermgmt.getUserIdDetails[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getUserIdDetails(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}usermgmt.getSmartCardURL[{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>
        service.getSmartCardURL(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      )))

    .match(`${p}usermgmt.clearOtherSession[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>{
        service.clearOtherSession(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      })))
    
    .match(`${p}usermgmt.smartCardLoginFailed[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
      requests.map(({ req, res }) =>{
        service.smartCardLoginFailed(req.params)
          .then(response => res.value(response))
          .catch(res.error)
      })))
}

module.exports = addRoutes;
